import React from "react";

// css
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="footer mt-5 text-center">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">

          </div>
          <div className="col-12 col-md-6">

          </div>
          <div className="col-12 text-center">
            <p className="text-extra-bold m-0 text-m"></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
